const getIsRequired = (errorMessage) => {

    const isRequired = (val, name, formState) => {
        //console.log ('is not blank', val)
        if (val) {
            return ''
        }
        else {
            return errorMessage
        }
    }

    return isRequired
}

const getMinLenght = (errorMessage, length) => {

    const isRequired = (val, name, formState) => {

        if (val.length >= length) {
            return ''
        }
        else {
            return errorMessage
        }
    }

    return isRequired
}



const stringToDate = function (dateString) {
    const [dd, mm, yyyy] = dateString.split(".");
    return new Date(`${yyyy}-${mm}-${dd}`);
};

const getIsBeyondToday = (errorMessage, length) => {

    const isBeyondToday = (val, name, formState) => {

        if (!val) {
            return ''
        }
        
        let CurrentDate = new Date()
        let GivenDate = stringToDate(val)

        if (GivenDate > CurrentDate) {
            return errorMessage
        } else {
            return ''
        }
    }

    return isBeyondToday
}

const getIsBeyondThreeYearOld = (errorMessage, length) => {

    const isBeyondToday = (val, name, formState) => {

        if (!val) {
            return ''
        }

        if (val.length !== 10) {
            return ''
        }
        
        let CurrentDateThreeAYearsAgo = new Date()
        let thisYear = CurrentDateThreeAYearsAgo.getFullYear()
        CurrentDateThreeAYearsAgo.setFullYear(thisYear-3)
        let GivenDate = stringToDate(val)

        if (GivenDate < CurrentDateThreeAYearsAgo) {
            return errorMessage
        } else {
            return ''
        }
    }

    return isBeyondToday
}

// Sjekker om for nærme foreldelse. Foreldelse er 3 år tilbake i tid så vi sjekker om fakturadato er senest (tidligst?) 35 mnd siden.
// Alt som er 3 år eller eldre blir allerede dekket av getIsBeyondThreeYearOld
const getIsBeyond35MonthsOld = (errorMessage, length) => {
    const isBeyondToday = (val, name, formState) => {
        if (!val) {
            return '';
        }

        if (val.length !== 10) {
            return '';
        }

        let givenDate = stringToDate(val);

        let threeYearsAgo = new Date();
        threeYearsAgo.setMonth(threeYearsAgo.getMonth() - 36);

        let thirtyFiveMonthsAgo = new Date();
        thirtyFiveMonthsAgo.setMonth(thirtyFiveMonthsAgo.getMonth() - 35);

        if (givenDate >= threeYearsAgo && givenDate < thirtyFiveMonthsAgo) {
            return errorMessage;
        }

        return '';
    };

    return isBeyondToday;
};




const getForfallEtterFaktDate = (errorMessage, length) => {

    const validatorFunc = (val, name, formState) => {

        if (!val) {
            return ''
        }

        if (!formState.fakturadato) {
            return ''
        }

        let fakturaDate = stringToDate(formState.fakturadato)
        let forfall = stringToDate(val)

        if (forfall < fakturaDate) {
            return errorMessage
        } else {
            return ''
        }
    }

    return validatorFunc
}


export const getFakturaFormValidators = (messages) => {

    const fakturanummerIsRequired = getIsRequired(messages['fakturanummerIsRequired'])
    const fakturatekstIsRequired = getIsRequired(messages['fakturatekstIsRequired'])
    const forfallsdatoIsRequired = getIsRequired(messages['forfallsdatoIsRequired']) 
    const isBeyondThreeYearsOld = getIsBeyondThreeYearOld(messages['isBeyondThreeYearsOld'])
    const isBeyond35MonthsOld = getIsBeyond35MonthsOld(messages['isBeyond35MonthsOld'])
    const fakturadatoIsRequired = getIsRequired(messages['fakturadatoIsRequired'])
    const valutaIsRequired = getIsRequired(messages['valutaIsRequired'])
    const belopIsRequired = getIsRequired(messages['belopIsRequired'])

    const minLength10 = getMinLenght(messages['minLength10'], 10)
    const isBeyondToday = getIsBeyondToday(messages['isBeyondToday'], 10)
    const isForfallOk = getForfallEtterFaktDate(messages['isForfallOk'], 10)
    
    const formValidators = {

        fakturanummer: [
            fakturanummerIsRequired
        ],
        kid: [

        ],
        fakturatekst: [
            fakturatekstIsRequired
        ],

        forfallsdato: [
            fakturadatoIsRequired,
            minLength10,            
            isBeyondToday,
            isBeyondThreeYearsOld,
            isForfallOk,
        ],
        fakturadato: [
            fakturadatoIsRequired,
            minLength10,
            isBeyondToday,
            isBeyond35MonthsOld,
            isBeyondThreeYearsOld,
        ],
        valuta: [
            valutaIsRequired
        ],
        belop: [
            belopIsRequired
        ]    
    }

    return formValidators
}


